/**
 * Where each retired `/admin/data?tab=…` URL now lives.
 *
 * SEPARATE FROM `modules.tsx` ON PURPOSE. The route manifest
 * (`rent-extras.routes.tsx`) is EAGER — its `lazyNamed` calls defer the page
 * chunks, but the manifest module itself is evaluated on every load, for every
 * user. `modules.tsx` imports every admin surface in the console, so importing
 * this map from there would drag the whole admin bundle into the eager graph
 * and undo the split that made six non-admin family members stop paying for
 * screens they can never open.
 *
 * This file imports nothing. It is strings.
 *
 * `tests/admin-modules.test.tsx` checks each destination against
 * `ADMIN_MODULES`, so the two cannot disagree despite living apart.
 */
export const DATA_TAB_REDIRECTS: Record<string, string> = {
  // Data health spans every module at once, so it went to System rather than
  // being filed arbitrarily under one of them.
  health: "/admin/system?tab=health",
  accounts: "/admin/module/accounts?tab=accounts",
  categories: "/admin/module/records?tab=categories",
  commitments: "/admin/module/budget?tab=commitments",
  import: "/admin/module/records?tab=import",
  "import-wallet-csv": "/admin/module/records?tab=import-wallet-csv",
  "custom-fields": "/admin/module/records?tab=custom-fields",
  "recycle-bin": "/admin/module/records?tab=recycle-bin",
};
